"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../shared/core");
var section_ids_1 = require("../../../../section-ids");
var Loading = function () {
    var _a = (0, core_1.useComponents)(), Card = _a.Card, SkeletonHeading = _a.SkeletonHeading, SkeletonText = _a.SkeletonText, Heading1 = _a.Heading1, SkeletonCTA = _a.SkeletonCTA;
    return (react_1.default.createElement(Card, { "data-testid": section_ids_1.PROFILE_EDIT_EMAIL_LOADING },
        react_1.default.createElement(SkeletonText, { lines: 1 }),
        react_1.default.createElement(SkeletonHeading, { headingComponent: Heading1 }),
        react_1.default.createElement(SkeletonText, { lines: 4 }),
        react_1.default.createElement(SkeletonCTA, null)));
};
exports.Loading = Loading;
